import rimg from '@pixelunion/rimg-shopify';

export default class ProductSlideshow {
  constructor(component) {
    this.el = component.el;
    this.$images = $(component.el);
    this.$images.on('click', '.product-thumbnails-navigation-previous, .product-thumbnails-navigation-next', event => this.moveProductThumbnails(event));
    this.productThumbnailsWrapper = this.$images.find('.product-gallery--navigation-wrapper');
    this.productThumbnails = this.$images.find('.product-gallery--navigation');
    this.productThumbnail = this.$images.find('.product-gallery--media-thumbnail');

    this.moving = false;

    if (this.productThumbnails.length > 0) {
      rimg.watch(this.productThumbnails.get(0));
    }

    if (this.productThumbnails.hasClass('has-side-scroll')) {
      this.setupProductSlideshow();
      this.productThumbnails.on('rimg:load', () => { this.setupProductSlideshow(); });

      $(window).resize((e) => {
        const selectedThumbnail = this.el.querySelector('[data-product-gallery-selected="true"]');
        this.setupProductSlideshow(true);
        if (selectedThumbnail) {
          this.selectThumbnail(selectedThumbnail.dataset.media);
        } else {
          this.productThumbnails.css({
            left: 0,
          });
        }
      });
    }
  }

  setupProductSlideshow(onResize) {
    let tallestImageHeight = 0;
    let containerWidth = 0;

    this.productThumbnailPadding = parseInt(this.productThumbnail.css('padding-left'), 10) * 2;
    this.productThumbnailMargin = parseInt(this.productThumbnail.css('margin-right'), 10) * 2;

    this.productThumbnail.width((this.productThumbnailsWrapper.width() / 4) - this.productThumbnailPadding - this.productThumbnailMargin);

    for (let i = 0; i < this.productThumbnail.length; i++) {
      const image = this.productThumbnail[i];
      const currentImageHeight = image.getBoundingClientRect().height;
      const currentImageWidth = image.getBoundingClientRect().width + this.productThumbnailMargin;

      if (currentImageHeight > tallestImageHeight) {
        tallestImageHeight = currentImageHeight;
      }

      currentImageWidth += this.productThumbnailMargin;

      containerWidth += currentImageWidth;
    }

    this.productThumbnailsWrapper.height(tallestImageHeight);
    this.productThumbnails.width(containerWidth);
  }

  moveProductThumbnails(e) {
    const containerWidth = this.productThumbnailsWrapper.width();
    const currentPosition = this.productThumbnails.position().left;

    // To prevent moving the slider too far to one side or another by clicking next/previous when it's between slides
    // we need to check that the current position is a multiple of the slide width (ie. we only ever want it to move a full slide)
    // Rounding the values makes them easier to compare, but creates a small margin of error of 1px, so we should check the position
    // against the rounded container width ± 1
    const absCurrentPosition = Math.round(Math.abs(currentPosition));
    const roundedContainerWidth = Math.round(containerWidth);
    const positionRemainder = absCurrentPosition % roundedContainerWidth;
    const positionRemainderMax = roundedContainerWidth + 1;
    const positionRemainderMin = roundedContainerWidth - 1;

    if (positionRemainder !== 0 && positionRemainder !== positionRemainderMax && positionRemainder !== positionRemainderMin) return;

    if ($(e.currentTarget).hasClass('product-thumbnails-navigation-next') && ((currentPosition - containerWidth) > -(this.productThumbnails.outerWidth()))) {
      this.productThumbnails.css({
        left: currentPosition - containerWidth,
      });
    } else if ($(e.target).hasClass('product-thumbnails-navigation-previous') && (currentPosition < 0)) {
      this.productThumbnails.css({
        left: currentPosition + containerWidth,
      });
    }
  }

  selectThumbnail(mediaId) {
    if (this.productThumbnails.length === 0) return;

    const thumbnail = this.productThumbnails[0].querySelector(`[data-media="${mediaId}"]`);
    const thumbnailIndex = thumbnail.dataset.productGalleryThumbnail;
    const slides = Math.floor(thumbnailIndex / 4);
    const containerWidth = this.productThumbnailsWrapper.width();
    const newPosition = -(containerWidth * slides);

    this.productThumbnails.css({
      left: newPosition,
    });
  }
}
